/**
 * 旧版 Thymeleaf 页面路径映射配置
 *
 * 用途：将后端菜单中 /xxx/init 格式的旧页面 URL 映射为实际的 Thymeleaf 模板路径
 *
 * 背景：项目中存在 118+ 个 Thymeleaf 旧页面，通过 Controller 的 @RequestMapping("init") 返回模板。
 * 后端菜单 URL 格式为 /xxx/init（数据库 my_module 表的 url 字段），前端需要在 iframe 中加载这些页面。
 *
 * 使用方式：
 *   - 后端菜单 URL 以 /xxx/init 结尾 → 在此查找映射
 *   - 查找到 → 使用映射后的 .html 路径（iframe 加载）
 *   - 未找到 → 自动推导：去掉 /init 后缀，补 .html（如 /foo/bar/init → foo/bar/bar.html）
 *
 * 新增旧页面时，只需在此添加一行配置即可，无需修改 permission.js 业务逻辑。
 *
 * key 格式：去掉前导 / 后的后端菜单 URL，如 airwayZdmanage/init
 * value 格式：实际 Thymeleaf 模板相对路径（相对于 templates/modules/），如 ads/airwayZdmanage/airwayZdmanage.html
 */

// key: 后端菜单 URL（去掉开头的 /）
// value: 实际 Thymeleaf 模板相对路径（相对于 modules/）
const LEGACY_PAGE_MAPPING = {
  // ==================== ads 模块（核心业务） ====================
  'airlineCompany/init': 'ads/airlineCompany/airlineCompany.html',
  'airlineCompanySetting/init': 'ads/airlineCompany/airlineCompanySetting.html',
  'airlines/init': 'ads/airlines/airlinesNew.html',
  'airlinesFreight/init': 'ads/airlinesFreight/airlinesFreight.html',
  'airlinesInfo/init': 'ads/airlinesInfo/airlinesInfo.html',
  'airlinesLocalFee/init': 'ads/airlinesLocalFee/airlinesLocalFee.html',
  'airlinesprice/init': 'ads/airlinesprice/airlinespriceV1.html',
  'airlinesTransitFee/init': 'ads/airlinesTransitFee/transitFee.html',
  'airport/init': 'ads/airport/airport.html',
  'airwayCustomer/init': 'ads/airwayCustomer/airwayCustomer.html',
  'airwayZdmanage/init': 'ads/airwayZdmanage/airwayZdmanage.html',
  'arrivalRouteData/init': 'ads/arrivalRouteData/arrivalRouteData.html',
  'companyArea/init': 'ads/companyArea/companyArea.html',
  'companyLimit/init': 'ads/companyLimit/companyLimit.html',
  'control/init': 'ads/control/control.html',
  'controlAl/init': 'ads/control/control_al.html',
  'controlFg/init': 'ads/control/control_fg.html',
  'countries/init': 'ads/countries/countries.html',
  'currency/init': 'ads/currency/currency.html',
  'customer/init': 'ads/customer/customer.html',
  'destinationPortFeeAllocation/init': 'ads/destinationPortFeeAllocation/destinationPortFeeAllocation.html',
  'dictionary/init': 'ads/dictionary/dictionary.html',
  'emailManage/init': 'ads/emailManage/emailManage.html',
  'export/init': 'ads/export/export.html',
  'exportRemark/init': 'ads/exportRemark/exportRemark.html',
  'freightManage/init': 'ads/freightManage/freightManage.html',
  'freightManage/initABK': 'ads/freightManage/freightManageABK.html',
  'freightRegulation/init': 'ads/freightRegulation/freightRegulation.html',
  'needOrder/init': 'ads/needOrder/needOrder.html',
  'news/init': 'ads/news/news.html',
  'notice/init': 'ads/notice/notice.html',
  'order/init': 'ads/order/order.html',
  'pay/init': 'ads/pay/pay.html',
  'pickupfee/init': 'ads/pickupfee/pickupfee.html',
  'platformFeeAllocation/init': 'ads/platformFeeAllocation/platformFeeAllocation.html',
  'platformManagement/init': 'ads/platformManagement/platformManagement.html',
  'productprogram/init': 'ads/productprogram/productprogram.html',
  'rateRegulation/init': 'ads/rateRegulation/rateRegulation.html',
  'rcOperator/init': 'ads/rcOperator/rcOperator.html',
  'recipientInfo/init': 'ads/recipientInfo/recipientInfo.html',
  'routeInformation/init': 'ads/routeInformation/routeInformation.html',
  'routeMaintain/init': 'ads/routeMaintain/routeMaintain.html',
  'senderInfo/init': 'ads/senderInfo/senderInfo.html',
  'specialLine/init': 'ads/specialLine/specialLine.html',
  'surcharge/init': 'ads/surcharge/surcharge.html',
  'system/init': 'ads/system/systemConfig.html',
  'video/init': 'ads/video/video.html',
  // airportDeliveryFee 的 Controller @RequestMapping 为 "init"，数据库 URL 特殊
  'airportDeliveryFee/init': 'ads/airportDeliveryFee/airportDeliveryFee.html',

  // ==================== airway 模块（空运业务） ====================
  'agreementConfig/init': 'airway/agreementConfig/agreementConfig.html',
  'bookingManage/init': 'airway/bookingManage/bookingManageALL.html',
  'checkConfig/init': 'airway/checkConfig/checkConfig.html',
  'consumablesManagement/init': 'airway/consumablesManagement/consumablesManagement.html',
  'deliveryForecast/init': 'airway/deliveryForecast/deliveryForecast.html',
  'eqcheckManage/init': 'airway/eqcheckManage/eqcheckManage.html',
  'fixedBoardPlan/init': 'airway/fixedBoardPlan/fixedBoard.html',
  'flightJztime/init': 'airway/flightJztime/flightJztime.html',
  'hkFollow/init': 'airway/hkFollow/hkFollowALL.html',
  // 'hkFollow/init?type=ALL': 'airway/hkFollow/hkFollowALL.html',
  // 'hkFollow/init?type=HC': 'airway/hkFollow/hkFollowHC.html',
  // 'hkFollow/init?type=HD': 'airway/hkFollow/hkFollowHD.html',
  // 'hkFollow/init?type=HL': 'airway/hkFollow/hkFollowHL.html',
  // 'hkFollow/init?type=HJD': 'airway/hkFollow/hkFollowHJD.html',
  // 'hkFollow/init?type=HX': 'airway/hkFollow/hkFollowHX.html',
  // 'hkFollow/init?type=HZ': 'airway/hkFollow/hkFollowHZ.html',
  // 'hkFollow/init?type=HQX': 'airway/hkFollow/hkFollowHQX.html',
  'jdCenter/init': 'airway/jdCenter/jdCenter.html',
  'jzmanage/init': 'airway/warehouseJzmanage/warehouseJzmanage.html',
  'newsNotice/init': 'airway/newsNotice/newsNotice.html',
  'nozdhTally/init': 'airway/nozdhTally/nozdhTally.html',
  'operationRecord/init': 'airway/operationRecord/operationRecord.html',
  'operationRequire/init': 'airway/operationRequire/operationRequire.html',
  'pbtypeConfig/init': 'airway/pbtypeConfig/pbtypeConfig.html',
  'plateArrangement/init': 'airway/plateArrangement/plateArrangement.html',
  'preplanManifest/init': 'airway/preplanManifest/preplanManifestJZ.html',
  'punchPlanpr/init': 'airway/punchPlanpr/punchPlanpr.html',
  'refundOrder/init': 'airway/refundOrder/refundOrder.html',
  'routeTracking/init': 'airway/routeTracking/routeTracking.html',
  'specialRailwayLine/init': 'airway/specialRailwayLine/specialRailwayLine.html',
  'superfeeConfig/init': 'airway/superfeeConfig/superfeeConfig.html',
  'tallyCheck/init': 'airway/tallyCheck/tallyCheck.html',
  'tallyCheck/lhglInit':'airway/tallyCheck/tallyManagement.html',
  'waipeiManage/init': 'airway/waipeiManage/waipeiManage.html',
  'warehouseckgb/init': 'airway/warehouseckgb/warehouseckgb.html',
  'warehouseCost/init': 'airway/warehouseCost/warehouseCost.html',
  'warehouseManage/init': 'airway/warehouseManage/warehouseManage.html',
  'warehouseOperation/init': 'airway/warehouseOperation/warehouseOperation.html',
  'warehouseOperation/initRk': 'airway/warehouseOperation/rkWarehouseOperation.html',
  'warehouseStatistics/init': 'airway/warehouseStatistics/warehouseStatistics.html',
  'wbaZdmange/init': 'airway/wbaZdmange/wbaZdmange.html',
  'whOrderManage/init': 'airway/whOrderManage/whOrderManageYB.html',
  'workRecord/init': 'airway/warehouseWorkRecord/warehouseWorkRecord.html',
  'wpbookingManage/init': 'airway/wpbookingManage/wpbookingManageDHC.html',
  'xcScheduling/init': 'airway/xcScheduling/xcScheduling.html',

  // ==================== airfreightrate 模块（空运价格） ====================
  'positionManagement/init': 'airfreightrate/positionManagement/positionManagement.html',
  'priceInquiry/init': 'airfreightrate/priceInquiry/priceInquiry.html',

  // ==================== taktrack 模块（TMS 追踪） ====================
  'taktrack/init': 'taktrack/taktrack.html',
  'taktrackBdd/init': 'taktrack/taktrackBdd/taktrackBdd.html',
  'taktrackEx/init': 'taktrack/taktrackEx/taktrackEx.html',
  'taktrackFlq/init': 'taktrack/taktrackFlq/taktrackFlq.html',
  'taktrackOm/init': 'taktrack/taktrackOm/taktrackOm.html',
  'taktrackOrder/init': 'taktrack/taktrackOrder/taktrackOrder.html',
  'taktrackPfr/init': 'taktrack/taktrackPfr/taktrackPfr.html',
  'taktrackSeq/init': 'taktrack/taktrackSeq/taktrackSeq.html',
  'taktrackSpq/init': 'taktrack/taktrackSpq/taktrackSpq.html',
  'taktrackTi/init': 'taktrack/taktrackTi/taktrackTi.html',
  'taktrackWpt/init': 'taktrack/taktrackWpt/taktrackWpt.html',

  // ==================== order 模块（订单） ====================
  'tmorder/init': 'tmorder/orderOF.html',
  'tmorderWb/init': 'webcargo/list.html',
  'waybill/init': 'tmorder/waybill.html',
  'jdOrder/init': 'jdOrder/jdOrder.html',

  // ==================== ocean 模块（海运价格） ====================
  'ocean/ssFreight/init': 'ocean/ssfreight/freight.html',
  'overseasAirPrices/init': 'ocean/ssfreight/overseasAirPrices/airPrices.html',
  'overseasSfPrices/init': 'ocean/ssfreight/overseasSfPrices/sfPrices.html',

  // ==================== xp 模块（小包） ====================
  'xpBusiness/init': 'xp/xpBusiness/xpBusiness.html',
  'xpDocking/init': 'xp/xpDocking/xpDocking.html',
  'xpLimitData/init': 'xp/xpLimitData/xpLimitData.html',
  'xpRouteBj/init': 'xp/xpRouteBj/xpRouteBj.html',

  // ==================== sys 模块（系统管理后台） ====================
  'sys/accessCount/init': 'sys/accessCount/accessCount.html',
  'sys/accessCount/accessCountXq': 'sys/accessCount/accessCountXq.html',
  'sys/boardCensus/init': 'sys/boardCensus/boardCensus.html',
  'sys/enums/init': 'sys/enums/enums.html',
  'sys/freightStationData/init': 'sys/freightStationData/freightStationData.html',
  'sys/log/init': 'sys/log/logMonitor.html',
  'sys/module/init': 'sys/module/module.html',
  'sys/org/init': 'sys/org/org.html',
  'sys/param/init': 'sys/param/param.html',
  'sys/role/init': 'sys/role/role.html',
  'sys/user/init': 'sys/user/user.html',
}

/**
 * 根据后端菜单 URL 获取实际的 Thymeleaf 页面路径
 * @param {string} menuUrl - 后端菜单 URL，如 /airwayZdmanage/init
 * @returns {{ iframeUrl: string, isLegacy: boolean }}
 *   - iframeUrl: 实际 .html 路径，如 ads/airwayZdmanage/airwayZdmanage.html
 *   - isLegacy: 是否为旧页面（true 表示需要 iframe 加载）
 */
export function resolveLegacyPage(menuUrl, queryString) {
  if (!menuUrl) return { iframeUrl: '', isLegacy: false }

  // 剥离查询参数后再匹配：/hkFollow/init?type=ALL → /hkFollow/init
  // 查询参数由调用方（permission.js）单独处理，追加到最终的 iframeUrl 上
  let cleanUrl = menuUrl
  const qIndex = cleanUrl.indexOf('?')
  if (qIndex !== -1) {
    cleanUrl = cleanUrl.substring(0, qIndex)
  }

  const key = cleanUrl.replace(/^\//, '') // 去掉开头的 /

  // 0. 参数化路由：部分 /init 页面根据 type 参数返回不同模板
  //    preplanManifest/init?type=JZ  → preplanManifestJZ.html
  //    preplanManifest/init?type=AJYP → preplanManifestAJYP.html
  //    preplanManifest/init?type=WC  → preplanManifestWC.html
  if (key === 'preplanManifest/init' && queryString) {
    const typeMatch = queryString.match(/[?&]type=([^&]*)/)
    if (typeMatch) {
      const type = typeMatch[1]
      if (type === 'AJYP') {
        return { iframeUrl: 'airway/preplanManifest/preplanManifestAJYP.html', isLegacy: true }
      }
      if (type === 'WC') {
        return { iframeUrl: 'airway/preplanManifest/preplanManifestWC.html', isLegacy: true }
      }
    }
  }

  // 1. 优先查映射表（精确匹配）
  if (LEGACY_PAGE_MAPPING[key]) {
    return { iframeUrl: LEGACY_PAGE_MAPPING[key], isLegacy: true }
  }

  // 1.5 降级匹配：去掉模块前缀再查映射表
  //    postMessage 中 iframeUrl 带模块前缀（如 airway/bookingManage/init），
  //    而映射表 key 通常只有最后两级（bookingManage/init），需降级匹配
  const segments = key.split('/')
  if (segments.length >= 3) {
    const shortKey = segments.slice(-2).join('/')
    if (LEGACY_PAGE_MAPPING[shortKey]) {
      return { iframeUrl: LEGACY_PAGE_MAPPING[shortKey], isLegacy: true }
    }
  }

  // 2. 自动推导：/xxx/yyy/init → xxx/yyy/yyy.html
  //    适用于目录名与文件名一致的场景（大部分 Controller 都符合此规则）
  if (cleanUrl.endsWith('/init')) {
    const parts = cleanUrl.replace(/^\//, '').split('/')
    parts.pop() // 去掉 'init'
    const pageName = parts[parts.length - 1]
    const autoPath = `${parts.join('/')}/${pageName}.html`
    return { iframeUrl: autoPath, isLegacy: true }
  }

  // 3. 已经是 .html 路径，直接使用
  if (cleanUrl.endsWith('.html')) {
    return { iframeUrl: key, isLegacy: true }
  }

  return { iframeUrl: '', isLegacy: false }
}

export default LEGACY_PAGE_MAPPING
